export const environment = {
  production: false,
  baseUrl: "https://api.qa.aritzia.com",
  azure: {
    redirectUri: 'https://client-lookup-qa.aritzia.com'
  },
  idle: {
    inactive: 540,
    timeout: 60,
  },
  cdc: {
    servicePath: "/customers",
    uris: {
      accountSearch: "cdc/v2",
    },
  },
  apigee: {
    host: "https://api.qa.aritzia.com",
    tokenPath: "/oauth2/token",
    banner: "Aritzia_CA"
  },
  msGraphAPI:{
    host: "https://graph.microsoft.com",
    path: "/v1.0/users"
  }
};
